import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* industriesSagas() {
  yield mapSagasFromConfigurations('industries')(configurations)
}

export default industriesSagas;


// WEBPACK FOOTER //
// ./src/state/modules/industry/sagas.js